<!--
  Componente: HerramientasComponent
  Propósito: Diferenciar visualmente campos editables vs calculados (solo lectura).
  Nota: Se agregan clases y badges, y se marca readonly/disabled con estilo.
-->
<div class="container py-3">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8">
      <div class="card shadow-sm">
        <div class="card-body p-4">
          <h1 class="h4 mb-1">Herramientas</h1>
          <p class="text-muted mb-4">
            Los campos <span class="badge text-bg-primary">Editable</span> se pueden modificar.
            Los campos <span class="badge text-bg-secondary">Automático</span> se calculan solos.
          </p>

          <form [formGroup]="form" novalidate>
            <div class="row g-3">

              <!-- Editable: unidadesRuta -->
              <div class="col-12">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="unidadesRuta">Cantidades de unidades de ruta</label>
                  <span class="badge text-bg-primary">Editable</span>
                </div>
                <input
                  id="unidadesRuta"
                  type="number"
                  class="form-control editable-field"
                  formControlName="unidadesRuta"
                  min="0"
                  step="1"
                  inputmode="numeric"
                  placeholder="Ej. 120"
                  [class.is-invalid]="isInvalid('unidadesRuta')"
                />
                <small class="form-text">Número entero positivo.</small>
                <small class="invalid-feedback">Ingrese un número entero positivo.</small>
              </div>

              <!-- Editable: porcInstaladas -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="porcInstaladas">% de unidades instaladas</label>
                  <span class="badge text-bg-primary">Editable</span>
                </div>
                <div class="input-group">
                  <input
                    id="porcInstaladas"
                    type="number"
                    class="form-control editable-field"
                    formControlName="porcInstaladas"
                    min="0"
                    max="100"
                    step="1"
                    inputmode="numeric"
                    placeholder="Ej. 35"
                    [class.is-invalid]="isInvalid('porcInstaladas')"
                  />
                  <span class="input-group-text">%</span>
                  <div class="invalid-feedback">Ingrese un porcentaje entero entre 0 y 100.</div>
                </div>
                <small class="form-text">Número entero positivo (0 a 100).</small>
              </div>

              <!-- Editable (sincronizado): unidadesInstaladas -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="unidadesInstaladas">Unidades instaladas</label>
                  <span class="badge text-bg-primary">Editable</span>
                </div>
                <input
                  id="unidadesInstaladas"
                  type="number"
                  class="form-control editable-field"
                  formControlName="unidadesInstaladas"
                  step="1"
                  inputmode="numeric"
                  placeholder="Ej. 35"
                />
                <small class="form-text">
                  Campo sincronizado: puede modificar unidades instaladas o porcentaje.
                </small>
              </div>

              <!-- Editable: diasAscensosSemana -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="diasAscensosSemana">Días de ascensos por semana</label>
                  <span class="badge text-bg-primary">Editable</span>
                </div>
                <input
                  id="diasAscensosSemana"
                  type="number"
                  class="form-control editable-field"
                  formControlName="diasAscensosSemana"
                  min="0"
                  step="1"
                  inputmode="numeric"
                  placeholder="Ej. 6"
                  [class.is-invalid]="isInvalid('diasAscensosSemana')"
                />
                <small class="form-text">Número entero positivo.</small>
                <small class="invalid-feedback">Ingrese un número entero positivo.</small>
              </div>

              <!-- Editable: ascensosPersonaDia -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="ascensosPersonaDia">Ascensos/descensos por persona por día</label>
                  <span class="badge text-bg-primary">Editable</span>
                </div>
                <input
                  id="ascensosPersonaDia"
                  type="number"
                  class="form-control editable-field"
                  formControlName="ascensosPersonaDia"
                  min="0"
                  step="1"
                  inputmode="numeric"
                  placeholder="Ej. 2"
                  [class.is-invalid]="isInvalid('ascensosPersonaDia')"
                />
                <small class="form-text">Número entero positivo.</small>
                <small class="invalid-feedback">Ingrese un número entero positivo.</small>
              </div>

              <!-- Editable: diaInicio -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="diaInicio">Día de inicio del muestreo</label>
                  <span class="badge text-bg-primary">Editable</span>
                </div>
                <input
                  id="diaInicio"
                  type="number"
                  class="form-control editable-field"
                  formControlName="diaInicio"
                  min="1"
                  max="30"
                  step="1"
                  inputmode="numeric"
                  placeholder="Ej. 1"
                  [class.is-invalid]="isInvalid('diaInicio')"
                />
                <small class="form-text">Rango recomendado: 1 a 30.</small>
                <small class="invalid-feedback">Ingrese un número entero válido.</small>
              </div>

              <!-- Editable: diaFinal -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="diaFinal">Día final del muestreo</label>
                  <span class="badge text-bg-primary">Editable</span>
                </div>
                <input
                  id="diaFinal"
                  type="number"
                  class="form-control editable-field"
                  formControlName="diaFinal"
                  min="1"
                  max="30"
                  step="1"
                  inputmode="numeric"
                  placeholder="Ej. 30"
                  [class.is-invalid]="isInvalid('diaFinal')"
                />
                <small class="form-text">Rango recomendado: 1 a 30.</small>
                <small class="invalid-feedback">Ingrese un número entero válido.</small>
              </div>

              <!-- Automático: ascensosSemanales -->
              <div class="col-12">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="ascensosSemanales">Ascensos semanales</label>
                  <span class="badge text-bg-secondary">Automático</span>
                </div>
                <input
                  id="ascensosSemanales"
                  type="number"
                  class="form-control readonly-field"
                  formControlName="ascensosSemanales"
                  readonly
                />
                <small class="form-text">Cálculo: días por semana × ascensos/descensos por día.</small>
              </div>

              <!-- Automático: ascensosMes -->
              <div class="col-12">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="ascensosMes">Ascensos por mes</label>
                  <span class="badge text-bg-secondary">Automático</span>
                </div>
                <input
                  id="ascensosMes"
                  type="text"
                  class="form-control readonly-field"
                  [value]="ascensosMes"
                  readonly
                />
                <small class="form-text">
                  Cálculo: <strong>Ascensos Semanales × 4.32</strong> (promedio de semanas por mes).
                </small>
              </div>
            </div>

            <hr class="my-4" />

            <h2 class="h5 mb-2">Resultados</h2>

            <div class="row g-3">
              <!-- Automático: vistasMes -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="vistasMes">Vistas del muestreo</label>
                  <span class="badge text-bg-secondary">Automático</span>
                </div>
                <input
                  id="vistasMes"
                  type="number"
                  class="form-control readonly-field"
                  formControlName="vistasMes"
                  readonly
                />
                <small class="form-text">Se calcula con base en el rango de días y unidades instaladas.</small>
              </div>

              <!-- Automático: diasAbiertos -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="diasAbiertos">Días abiertos</label>
                  <span class="badge text-bg-secondary">Automático</span>
                </div>
                <input
                  id="diasAbiertos"
                  type="number"
                  class="form-control readonly-field"
                  formControlName="diasAbiertos"
                  readonly
                />
              </div>

              <!-- Automático: vistasSemana -->
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-1" for="vistasSemana">Vistas por semana</label>
                  <span class="badge text-bg-secondary">Automático</span>
                </div>
                <input
                  id="vistasSemana"
                  type="number"
                  class="form-control readonly-field"
                  formControlName="vistasSemana"
                  readonly
                />
              </div>
            </div>

            <hr class="my-4" />

            <div class="d-flex flex-column flex-md-row gap-2 justify-content-end">
              <button type="button" class="btn btn-primary" (click)="calcular()">
                Validar / Recalcular
              </button>
              <button type="button" class="btn btn-outline-secondary" (click)="limpiar()">
                Limpiar
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Leyenda -->
      <div class="alert alert-light border mt-3 mb-0">
        <div class="d-flex flex-wrap gap-2 align-items-center">
          <span class="badge text-bg-primary">Editable</span>
          <span class="text-muted">Se puede modificar.</span>
          <span class="badge text-bg-secondary ms-3">Automático</span>
          <span class="text-muted">Se calcula y es solo lectura.</span>
        </div>
      </div>

    </div>
  </div>
</div>
